// @ts-nocheck
/**
 * ファンド定義
 * 地域ファンド、大会メタファンド、カテゴリファンド
 */

// ファンドタイプ
export const FUND_TYPES = {
  REGION: 'region',
  META: 'meta',
  CATEGORY: 'category',
};

// 地域ファンド定義（6地域）
export const REGION_FUNDS = {
  region_fire: {
    id: 'region_fire',
    name: '血呪の峠ファンド',
    type: FUND_TYPES.REGION,
    attribute: '炎',
    categories: ['ドラゴン', '炎霊'],
    informantId: 'karuno',
    basePrice: 10000,
    description: '火山活動と炎の魔物の動向に連動',
    icon: '🔥',
  },
  region_water: {
    id: 'region_water',
    name: '深海アクアレギナファンド',
    type: FUND_TYPES.REGION,
    attribute: '水',
    categories: ['海竜', '人魚'],
    informantId: 'shellna',
    basePrice: 10000,
    description: 'ヴェルゼファールの眷属と海流変化に連動',
    icon: '💧',
  },
  region_light: {
    id: 'region_light',
    name: 'ルミナリス聖域ファンド',
    type: FUND_TYPES.REGION,
    attribute: '光',
    categories: ['天使', '聖騎士'],
    informantId: 'fine',
    basePrice: 10000,
    description: '聖典祭と光の儀式に連動',
    icon: '✨',
  },
  region_dark: {
    id: 'region_dark',
    name: '黒呪の大陸ファンド',
    type: FUND_TYPES.REGION,
    attribute: '闇',
    categories: ['魔女', '黒呪', 'ゴシック'],
    informantId: 'grim',
    basePrice: 10000,
    description: '魔女の呪いと亡霊の活動に連動',
    icon: '🌙',
  },
  region_primitive: {
    id: 'region_primitive',
    name: '虹羽密林ファンド',
    type: FUND_TYPES.REGION,
    attribute: '原始',
    categories: ['獣', '植物'],
    informantId: 'poron',
    basePrice: 10000,
    description: '繁殖期と密林の異変に連動',
    icon: '🌿',
  },
  region_future: {
    id: 'region_future',
    name: '時空の狭間ファンド',
    type: FUND_TYPES.REGION,
    attribute: '未来',
    categories: ['ゴーレム', '機械'],
    informantId: 'techno',
    basePrice: 10000,
    description: '時空の歪みとゴーレム暴走に連動',
    icon: '⚙️',
  },
};

// 大会メタファンド定義
// ※ meta_fire/meta_water は地域ファンドと重複するため削除
export const META_FUNDS = {
  meta_aggro: {
    id: 'meta_aggro',
    name: '速攻メタファンド',
    type: FUND_TYPES.META,
    style: 'aggro',
    description: '低コスト速攻が環境を支配（コスト2以下）',
    basePrice: 10000,
    icon: '⚡',
  },
  meta_control: {
    id: 'meta_control',
    name: 'コントロールメタファンド',
    type: FUND_TYPES.META,
    style: 'control',
    description: '長期戦デッキが勝つ（コスト5以上）',
    basePrice: 10000,
    icon: '🛡️',
  },
};

// カテゴリファンド定義
export const CATEGORY_FUNDS = {
  category_dragon: {
    id: 'category_dragon',
    name: '竜王の血脈ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['ドラゴン', 'ワイバーン', 'フェニックス', 'サラマンダー'],
    description: '翼持つ火の王者たち。竜族の覇権に賭ける',
    basePrice: 10000,
    icon: '🐉',
  },
  category_spirit: {
    id: 'category_spirit',
    name: '幽世の残響ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['スピリット', 'ゴースト'],
    description: '彷徨う魂と霊体。死後の世界からの投資',
    basePrice: 10000,
    icon: '👻',
  },
  category_bird: {
    id: 'category_bird',
    name: '天翔ける者ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['鳥・カラス', '鳥', 'スカイレジェンド', 'ウィング・トリビューン', '鳥・カモメ'],
    description: '空を支配する翼の者たち。蒼穹の覇者に賭ける',
    basePrice: 10000,
    icon: '🦅',
  },
  category_beast: {
    id: 'category_beast',
    name: '牙爪連合ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['ビースト', 'ビースト・猫', 'ビースト・狸', 'ビースト・狼', 'ビースト・鹿', 'ビースト・イノシシ'],
    description: '野生の獣たちの連合。本能と牙に賭ける',
    basePrice: 10000,
    icon: '🐾',
  },
  category_slime: {
    id: 'category_slime',
    name: '無限増殖ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['スライム', 'プラント'],
    description: '増殖する生命体。止まらない繁殖力に賭ける',
    basePrice: 10000,
    icon: '🟢',
  },
  category_machine: {
    id: 'category_machine',
    name: '鋼鉄の遺産ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['ゴーレム', 'マシン', 'エクラシア'],
    description: '古代機械文明の遺産。鋼鉄の意思に賭ける',
    basePrice: 10000,
    icon: '⚙️',
  },
  category_mage: {
    id: 'category_mage',
    name: '魔導の系譜ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['パペットマスター', '魔導士', 'ウィザード', '魔族'],
    description: '魔法を操る者たち。秘術の継承者に賭ける',
    basePrice: 10000,
    icon: '🔮',
  },
  category_abyss: {
    id: 'category_abyss',
    name: '深淵の眷属ファンド',
    type: FUND_TYPES.CATEGORY,
    categories: ['ソウルカース', 'アビスソウル', 'ディープシャドウ', 'ダークドウェラ', '虚蝕'],
    description: '闘の深淵に棲む者たち。虚無の力に賭ける',
    basePrice: 10000,
    icon: '👁️',
  },
};

// 全ファンドを統合
export const ALL_FUNDS = {
  ...REGION_FUNDS,
  ...META_FUNDS,
  ...CATEGORY_FUNDS,
};

// ファンドIDからファンド情報を取得
export function getFund(fundId) {
  return ALL_FUNDS[fundId] || null;
}

// タイプ別ファンド一覧を取得
export function getFundsByType(type) {
  return Object.values(ALL_FUNDS).filter((fund) => fund.type === type);
}

// 属性に関連するファンドを取得
export function getFundsByAttribute(attribute) {
  return Object.values(ALL_FUNDS).filter(
    (fund) => fund.attribute === attribute
  );
}
